import axiosClient from '@/axiosClient';
import { API_ENDPOINTS } from '@/apiConfig';


export function useScheduleCalendar() {
  const fetchCalendarRecords = async ({ calendarType, employeeIds, startDate, endDateExclusive }) => {
    const endpoint = calendarType === 'covers'
      ? API_ENDPOINTS.searchCoverCalendar
      : API_ENDPOINTS.searchLeavesCalendar;
    const response = await axiosClient.post(endpoint, {
      employee_ids: employeeIds,
      start_date: startDate,
      end_date_exclusive: endDateExclusive,
      timezone: 'Europe/London'
    });

    if (!response.data || !Array.isArray(response.data.items)) {
      throw new Error('Invalid calendar response: expected an items array.');
    }
    return response.data.items;
  };

  return { fetchCalendarRecords };
}
